import React from 'react';
import { Box, Container, Icon, Flex, Heading, Text, Link, IconButton  } from '@chakra-ui/react';
import { FaReact, FaCss3Alt, FaNodeJs, FaHtml5, FaSass, FaGithub, FaPager } from 'react-icons/fa';
import { SiRedux, SiMaterialui, SiExpress, SiPostgresql, SiFirebase, SiStyledcomponents, SiJavascript } from "react-icons/si";
import { MdOutlineWeb } from "react-icons/md";
import '../css/Projects.css'
import { motion } from 'framer-motion'
import pgairlines from '../assets/cover.JPG'
import pifood from '../assets/pifood.JPG'
import brujula from '../assets/brujula.JPG'

export default function Projects() {
  return (
    <motion.div
      whileInView={{opacity: [0, 1]}}
      transition={{ duration: 0.5}}
    >
      <Box id='projects' p={10}>
        <Container maxW='container.lg' pt={14} pb={2}>
          <Heading as='h2' size='lg' noOfLines={1} pb={10}>Projects</Heading>

          <motion.div       
            whileInView={{opacity: [0, 1]}}
            transition={{ duration: 0.5}}
            >
            <Flex pb={20} alignItems='baseline' direction='row' wrap='wrap' justifyContent='space-between'>
              <div>
                <Heading as='h3' size='md'>Group Project - PG Airlines</Heading>
                <Flex pt={4} pb={4} gap={3}>
                  <Icon w={5} h={5} as={FaReact} />
                  <Icon w={5} h={5} as={SiRedux} />
                  <Icon w={5} h={5} as={SiMaterialui} />
                  <Icon w={5} h={5} as={FaCss3Alt} />
                  <Icon w={5} h={5} as={SiJavascript} />
                  <Icon w={5} h={5} as={SiExpress} />
                  <Icon w={5} h={5} as={FaNodeJs} />
                  <Icon w={5} h={5} as={SiPostgresql} />
                  <Icon w={5} h={5} as={SiFirebase} />
                </Flex>     
                <Text maxWidth='26rem' letterSpacing='1px'>
                  This project was designed to simulate a company selling airline tickets, in which users and future companies that want to publish their flights in our app will be able to register. <br />
                  It has a base model of Ecommerce, where we took into account 4 types of users: guest, user, admin (airline using the functionalities of the page) and superadmin (controls the registered users and airlines).
                </Text>       

                <Flex pt={4} pb={4} gap={3}>
                  <Link href='https://github.com/Sebas-montilla/PG-Airlines' target='_blank'>
                  <IconButton 
                    variant='outline'
                    icon={<FaGithub />} 
                  /> 
                  </Link>

                  <Link href='https://pg-airlines.vercel.app/' target='_blank'>
                  <IconButton 
                    variant='outline'                   
                    icon={<MdOutlineWeb />} 
                  /> 
                  </Link>
                </Flex>        
              </div>
                  
              <div className='p'>
                <div className='p-browser'>
                  <div className="p-circle"></div>
                  <div className="p-circle"></div>
                  <div className="p-circle"></div>
                </div>
                <Link href='https://pg-airlines.vercel.app/' target='_blank' rel='noreferrer'>
                  <img src={pgairlines} alt="Group project image" className='p-image'/>
                </Link>
              </div>
            </Flex>            
          </motion.div>

          <motion.div
            whileInView={{opacity: [0, 1]}}
            transition={{ duration: 0.5}}
          >
            <Flex pb={20} alignItems='baseline' direction='row' wrap='wrap' justifyContent='space-between'>
              <div>
                <Heading as='h3' size='md'>Individual Project - Food App</Heading>
                <Flex pt={4} pb={4} gap={3}>
                  <Icon w={5} h={5} as={FaReact} />
                  <Icon w={5} h={5} as={SiRedux} />
                  <Icon w={5} h={5} as={SiStyledcomponents} />
                  <Icon w={5} h={5} as={SiJavascript} />
                  <Icon w={5} h={5} as={SiExpress} />
                  <Icon w={5} h={5} as={FaNodeJs} />
                  <Icon w={5} h={5} as={SiPostgresql} />              
                </Flex> 
                <Text maxWidth='26rem' letterSpacing='1px'>
                The goal was build a single page application with the knowledge acquired during Henry's bootcamp. This SPA consumes data from an external API (Spoonacular API) and a database. From this information, different functionalities were created: 
                <br />
              - Recipe search
                <br />
              - Paginated, where 9 recipes are displayed per page<br />
              - Detail of each recipe<br />
              - Filtering by diet type and origin (API or database)<br />
              - Sort by name or health score ascending and descending<br />
              - Create a new recipe using a controlled form<br />
              - As an extra, the whole app is fully responsive<br />
                </Text>    

                <Flex pt={4} pb={4} gap={3}>
                <Link href='https://github.com/macamrs/PI-FOOD' target='_blank'>
                  <IconButton 
                    variant='outline'
                    icon={<FaGithub />} 
                  /> 
                  </Link>

                  <Link href='https://pi-food-vert.vercel.app/' target='_blank'>
                  <IconButton 
                    variant='outline'
                    icon={<MdOutlineWeb />} 
                  /> 
                  </Link>
                </Flex>            
              </div>

              <div className='p'>
                <div className='p-browser'>
                  <div className="p-circle"></div>
                  <div className="p-circle"></div>
                  <div className="p-circle"></div>
                </div>
                <Link href='https://pi-food-vert.vercel.app/' target='_blank' rel='noreferrer'>
                  <img src={pifood} alt="Individual project image" className='p-image'/>
                </Link>
              </div>
            </Flex>            
          </motion.div>

          <motion.div
            whileInView={{opacity: [0, 1]}}
            transition={{ duration: 0.5}}
          >
            <Flex pb={16} alignItems='baseline' direction='row' wrap='wrap' justifyContent='space-between'>
              <div>
                <Heading as='h3' size='md'>Brujulapsi</Heading>
                <Flex pt={4} pb={4} gap={3}>
                  <Icon w={5} h={5} as={FaCss3Alt} />
                  <Icon w={5} h={5} as={FaHtml5} />
                  <Icon w={5} h={5} as={FaSass} />
                  <Icon w={5} h={5} as={SiJavascript} />              
                </Flex>   
                <Text maxWidth='26rem' letterSpacing='1px'>
                In October 2021, I finished in the Top 10 of Coderhouse's outstanding students. This allowed me to access the benefit of the Real Project, where they assign you a freelance project to put into practice the knowledge learned in the course. <br />
                With my team we put together a functional proposal using only HTML, CSS, SASS and JS for BrujulaPsi, a network of mental health professionals, specifically psychotherapists. 
                </Text>    

                <Flex pt={4} pb={4} gap={3}>
                  <Link href='https://github.com/macamrs/Brujulapsi-Final' target='_blank'>
                  <IconButton 
                    variant='outline'                   
                    icon={<FaGithub />} 
                  /> 
                  </Link>

                  <Link href='https://brujulapsi.vercel.app/' target='_blank'>
                  <IconButton 
                    variant='outline'                   
                    icon={<MdOutlineWeb />} 
                  /> 
                  </Link>
                </Flex>        
              </div>

                <div className='p'>
                  <div className='p-browser'>
                    <div className="p-circle"></div>
                    <div className="p-circle"></div>
                    <div className="p-circle"></div>
                  </div>
                  <Link href='https://brujulapsi.vercel.app/' target='_blank' rel='noreferrer'>
                    <img src={brujula} alt="Individual project image" className='p-image'/>
                  </Link>
                </div>                
            </Flex>            
          </motion.div>

        </Container>
      </Box>      
    </motion.div>

  )
}
